import { render } from "./OuterContentsFile.vue?vue&type=template&id=0319d5b4&scoped=true&ts=true"
import script from "./OuterContentsFile.vue?vue&type=script&lang=ts"
export * from "./OuterContentsFile.vue?vue&type=script&lang=ts"

import "./OuterContentsFile.vue?vue&type=style&index=0&id=0319d5b4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0319d5b4"]])

export default __exports__